import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { GameUiDetailsComponent } from './game-details.component';

@NgModule({
  imports: [CommonModule, MaterialModule, SharedPipesDateModule],
  declarations: [GameUiDetailsComponent],
  exports: [GameUiDetailsComponent],
})
export class GamesUiGameDetailsModule {}
